import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { IntlContext } from '@jutro/locale';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';
import metadata from './QuotePremium.metadata.json5';
import styles from './QuotePremium.module.scss'

function QuotePremium(props) {
    const { isComponentValid, submissionVM, updateCustomQuote, offeredQuote,
    showAdditionalFieldError} = props;
    const intlContext = useContext(IntlContext);
    const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);
    const [validCoverages, setValidCoverages] = useState();

    useEffect(() => {
        setValidCoverages(() => isComponentValid)
    }, [isComponentValid]);

    const calculatePremiumAndQuote = useCallback(() => {
        updateCustomQuote()
    }, [updateCustomQuote])

    const getPremiumValue = useCallback(() => offeredQuote ? offeredQuote.premium.total : null, [offeredQuote]);

    const diffCost = useCallback(() => {
        const transactionCost = _.get(offeredQuote, 'customQuoteExtension_TWIA.transactionCost_TWIA.amount')
        const formattedDiffCost = intlContext.formatNumber(transactionCost, {
            style: 'currency',
            currency: 'USD'
        });

        if (transactionCost > 0) {
            return `+${formattedDiffCost}`;
        }

        return formattedDiffCost;
    }, [intlContext, offeredQuote]);

    // DE15658
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        totalPremium: {
            visible: !showAdditionalFieldError &&
                _.get(offeredQuote, 'premium.total') !== undefined && !isPolicyChange,
            value: getPremiumValue()
        },
        break: {
            visible: !showAdditionalFieldError &&
                _.get(offeredQuote, 'premium.total') !== undefined,
        },
        totalPremiumReadOnly: {
            visible: showAdditionalFieldError ||
                _.get(offeredQuote, 'premium.total') === undefined
        },
        calculatePremiumButton: {
            disabled: (validCoverages === false) || (!showAdditionalFieldError &&
                _.get(offeredQuote, 'premium.total') !== undefined)
        },
        premiumDiff: {
            value: diffCost()
        },
        premiumLayout: {
            visible: !showAdditionalFieldError &&
                _.get(offeredQuote, 'premium.total') !== undefined && isPolicyChange
        },
        totalPremiumTitle:{
            visible: !isPolicyChange
        },
        totalAnnualPremium: {
            // eslint-disable-next-line no-secrets/no-secrets
            value: _.get(offeredQuote, 'customQuoteExtension_TWIA.totalAnnualPremium_TWIA')
        },
        currentPremium: {
            // eslint-disable-next-line no-secrets/no-secrets
            value: _.get(offeredQuote, 'customQuoteExtension_TWIA.previousTotalCost_TWIA')
        },
        adjustedPremium: {
            value: _.get(offeredQuote, 'customQuoteExtension_TWIA.totalCost_TWIA')
        },
        quotePremium: {
            className: !showAdditionalFieldError &&
            _.get(offeredQuote, 'premium.total') !== undefined && isPolicyChange 
            ? styles.premiumChangecard
            : styles.premiumcard
        },
        premiumContent: {
            className: !showAdditionalFieldError &&
            _.get(offeredQuote, 'premium.total') !== undefined && isPolicyChange 
            ? styles.premiumchangeinternaldiv
            : styles.premiuminternaldiv
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
        },
        resolveCallbackMap: {
            updateAndQuote: calculatePremiumAndQuote
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

QuotePremium.propTypes = {
    data: PropTypes.shape({}).isRequired,
};

export default QuotePremium;
